<template>
  <container style="background: #fff;">
    <div class="content">
      <img v-for="item in imgList" :src="`data:image/jpg;base64,${item}`" alt="">
    </div>
  </container>
</template>

<style lang="less" rel="stylesheet/less" scoped="">
  .content {
    padding: 2rem 0;
    font-size: 1.4rem;
    line-height: 2.8rem;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
</style>
<script  >
  import webApi from '../../request/webapi';
  import { mapState } from 'vuex';

  export default{
    props: {},
    data() {
      return {
        contractNumber: this.$route.query.contractNumber,
        imgList: []
      };
    },
    computed: {
      ...mapState({
        // 用户信息
        user: (state) => state.userState.user.userId || '',
      }),
    },
    beforeRouteEnter(to, from, next) {
      document.title = to.query.name;
      next();
    },
    mounted() {
      this.$showLoader({ text: 'Loading' });
      this.getImg();
    },
    methods: {
      async getImg() {
        const contractNumber = this.contractNumber;
        const userId = this.user;
        try {
          const res = await webApi.query.lookContractNum({contractNumber, userId});
          const {statusCode, data} = res;
          if (statusCode !== 200) {
            return this.$showToast({text: '获取协议内容失败，请重试'})
          }
          if(data.length > 0) {
            this.imgList = data;
          }

        } catch(e) {
          console.error(e);
        } finally {
          this.$hideLoader();
        }
      },
    }
  };
</script>
